
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11615',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11615",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.449",
  "dashboard-client-types": "static-1.240",
  "data-fetching-client": "static-1.9494",
  "foundations-components": "static-1.7562",
  "foundations-components-legacy": "static-1.587",
  "foundations-theming": "static-1.4230",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.78",
  "head-dlb": "static-1.4841",
  "hs-test-utils": "static-1.7822",
  "hub-http-shared-msw-handlers": "static-1.9519",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11249",
  "I18n": "static-7.1575",
  "jasmine-runner": "static-1.6290",
  "marketplace-storefront-base": "static-1.11675",
  "quartz": "static-1.6759",
  "react-dlb": "static-1.73",
  "react-rhumb": "static-1.16469",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2680",
  "reporting-testing-lib": "static-1.8538",
  "settings-ui-lib": "static-1.12340",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6769",
  "ui-addon-i18n": "static-1.10961",
  "ui-addon-react-router-dom": "static-1.9363",
  "unified-auth": "static-1.239",
  "unified-auth-core-lib": "static-1.520",
  "usage-tracker": "static-1.7153",
  "usage-tracker-core": "static-1.7003",
  "customer-data-property-utils": "static-1.7897",
  "history": "static-4.47",
  "hub-http": "static-1.6037",
  "integrations-lib": "static-1.15482",
  "marketplace-ui-common": "static-1.19001",
  "property-management-iframe": "static-1.12414",
  "quartz-config": "static-1.537",
  "quartz-core": "static-1.5978",
  "quartz-routing": "static-1.189",
  "quick-fetch": "static-1.3753",
  "react": "static-7.180",
  "rpc-client-utils": "static-1.4452",
  "ts-schema": "static-1.3921",
  "ui-universal-auth": "static-1.8725",
  "UIComponents": "static-3.8196",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.405",
  "hs-promise-rejection-tracking": "static-1.5387",
  "PortalIdParser": "static-2.367",
  "raven": "static-3.5725",
  "raven-hubspot": "static-1.6032",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3246",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3036",
  "quartz-webpack": "static-1.2983",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3831",
  "floating-ui": "static-1.52",
  "foundations-assets": "static-1.4653",
  "foundations-theming-specialty": "static-1.1946",
  "framer-motion": "static-1.68",
  "hs-story-utils": "static-1.9244",
  "react-aria": "static-1.62",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5191",
  "react-virtualized": "static-2.95",
  "StyleGuideUI": "static-3.484",
  "tanstack-table": "static-1.51",
  "trellis-assets": "static-1.1269",
  "ui-fonts": "static-1.511",
  "ui-images": "static-2.1097",
  "bend-plugin-foundations-theming": "static-1.2713",
  "foundations-theming-base": "static-1.3215",
  "stylex": "static-1.28",
  "HeadJS": "static-2.713",
  "hs-test-utils-bend-plugin": "static-1.2933",
  "msw": "static-1.39",
  "testing-library": "static-1.148",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.217",
  "moment-timezone": "static-5.79",
  "jasmine": "static-4.4144",
  "ai-components-ui-library": "static-1.8400",
  "ai-rendering-library": "static-1.9359",
  "chirp-fetch": "static-1.1700",
  "connections-embed-lib": "static-1.662",
  "copilot-toolkit": "static-1.10582",
  "laboratory-lib": "static-3.6977",
  "marketplace-embed": "static-1.21524",
  "marketplace-ui-details": "static-1.8897",
  "marketplace-ui-reviews": "static-1.18957",
  "marketplace-ui-tracking": "static-1.13172",
  "sanitize-text": "static-1.7962",
  "ui-addon-video-player": "static-1.8514",
  "usage-tracker-multi": "static-1.5567",
  "usage-tracker-session-replay": "static-1.4839",
  "wootric-nps": "static-1.6802",
  "apollo-link-hub-http": "static-2.4469",
  "immer": "static-1.33",
  "immerable": "static-1.3973",
  "highcharts": "static-8.100",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2387",
  "reporting-data": "static-1.66605",
  "cssUtils": "static-1.737",
  "flux-actions": "static-1.310",
  "HubStyle": "static-2.11557",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10028",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10190",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7143",
  "icons": "static-2.623",
  "marketplace-ui-apps-core": "static-1.17534",
  "storybook-react": "static-1.29",
  "trellis-story-utils": "static-1.4338",
  "foundations-components-test-utils": "static-1.5045",
  "quartz-i18n": "static-1.434",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3549",
  "customer-data-objects": "static-1.7466",
  "property-translator": "static-1.5229",
  "frontend-preferences-client": "static-1.7742",
  "hs-promise-utils": "static-1.5411",
  "hubspot-apollo-client": "static-1.4698",
  "integrations-error-boundary-lib": "static-1.12897",
  "integrations-tracking-lib": "static-1.5406",
  "native-integrations-shared-strings": "static-1.7606",
  "reselect": "static-2.16",
  "sanitize": "static-1.4293",
  "superstore": "static-1.4588",
  "ui-shepherd-react": "static-3.9964",
  "ai-settings-ui-library": "static-1.7517",
  "hub-http-janus": "static-1.798",
  "hubspotter-http": "static-1.4495",
  "immutable-less": "static-1.4472",
  "marketplace-ui-client-types": "static-1.16408",
  "nav-meta": "static-1.28967",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10056",
  "ui-addon-upgrades": "static-9.17684",
  "inbound-db-properties-service-client": "static-1.3691",
  "property-management-common": "static-1.4701",
  "ui-addon-iframeable": "static-1.8864",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.486",
  "module-federation": "static-1.19",
  "quartz-auth": "static-1.434",
  "quartz-head": "static-1.424",
  "quartz-test": "static-1.434",
  "quartz-tracking": "static-1.138",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2968",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20409",
  "ContentUtils": "static-1.67676",
  "sassPrefix": "static-1.152",
  "avatar-components": "static-1.2305",
  "customer-data-filters-ui": "static-1.38969",
  "customer-data-objects-ui-components": "static-1.12826",
  "customer-data-reference-ui-components": "static-1.12964",
  "embedded-academy-lib": "static-1.13614",
  "ExportDialog": "static-6.10205",
  "highlight.js": "static-1.75",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40705",
  "reporting-snowflake": "static-1.55223",
  "reporting-ui-components": "static-2.63876",
  "reporting-visualizations": "static-1.58681",
  "ui-addon-teams": "static-1.21267",
  "magpie-lib": "static-1.5412",
  "magpie-types": "static-1.4872",
  "simple-logging-lib": "static-1.2868",
  "navigation-components": "static-1.17330",
  "ai-studio-lib": "static-1.11050",
  "developer-experience-shared-components": "static-1.10301",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7810",
  "ui-tool-access": "static-1.9963",
  "usage-based-billing-components-lib": "static-1.8058",
  "usage-tracker-anonymous": "static-1.5570",
  "usage-tracker-public": "static-1.6964",
  "amplitude-session-replay-browser": "static-1.56",
  "inbound-db-meta-service-client": "static-1.3437",
  "persist-promise": "static-1.3525",
  "reference-resolvers": "static-1.7979",
  "ui-extensibility-client-types": "static-1.3761",
  "hubspot-apollo-cache": "static-1.157",
  "universal-page-editor-lib": "static-1.2818",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2235",
  "merchandise-lib": "static-1.260",
  "atom": "static-1.4887",
  "purchase-motions-components": "static-1.5507",
  "salesImages": "static-1.521",
  "batch-promise": "static-1.1368",
  "crm-component-utils": "static-1.38524",
  "crm-properties-common-lib": "static-1.5690",
  "framework-data-schema-resolvers": "static-1.6691",
  "reference-resolvers-lite": "static-1.7912",
  "navigation-messaging": "static-1.6657",
  "hubspotter-http-shared-msw-handlers": "static-1.9517",
  "cms-field-types": "static-1.4624",
  "content-icons-ui": "static-1.2160",
  "conversations-skeleton-state": "static-1.7066",
  "crm-message-bus": "static-1.42417",
  "customer-data-filters-ui-msw-helpers": "static-1.21404",
  "customer-data-ui-utilities": "static-1.9640",
  "FormUrlGenerator": "static-2.4546",
  "framework-builder-read-service-client": "static-1.3850",
  "framework-data-schema-quick-fetch": "static-1.6596",
  "multi-account-reference-resolvers": "static-1.792",
  "onboarding-tours": "static-1.16292",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13111",
  "academy-common-lib": "static-1.13074",
  "content-assistance-lib": "static-1.7476",
  "dashboard-lib": "static-1.80704",
  "file-manager-components": "static-1.22953",
  "getting-started-shared-tasks": "static-1.17936",
  "hubspot-prosemirror": "static-1.17654",
  "hubspot-prosemirror-plugins": "static-1.17646",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19504",
  "share-with-third-party-component-lib": "static-1.8511",
  "ui-addon-draggable": "static-3.4583",
  "ui-asset-management-lib": "static-1.10734",
  "ui-business-units-lib": "static-1.8847",
  "user-context": "static-1.4916",
  "growth-payments-core": "static-1.24778",
  "reporting-plugins": "static-1.10009",
  "reporting-reports": "static-1.66283",
  "idb-keyval": "static-1.40",
  "reactive-lib": "static-1.542",
  "codemirror": "static-5.91",
  "feedback-loader": "static-1.28895",
  "react-codemirror": "static-1.10444",
  "apps-service-types": "static-1.3695",
  "oauth-service-types": "static-1.4064",
  "onboarding-scopes": "static-1.6280",
  "onboarding-tours-client": "static-1.4506",
  "platform-infra-nav-components": "static-1.7508",
  "subscription-experience-data-types": "static-1.14608",
  "crm-record-cards-service-types": "static-1.3460",
  "location-customization-utils-lib": "static-1.8621",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4329",
  "nav-client-types": "static-1.2175",
  "purchase-motions-api": "static-1.5510",
  "signup-constants": "static-1.18459",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3730",
  "card-properties-lib": "static-1.43577",
  "crm-actions": "static-1.6123",
  "crm-cards-data": "static-1.1251",
  "crm-cards-sdk": "static-1.42975",
  "customer-data-properties": "static-1.50850",
  "customer-data-properties-shared-msw-handlers": "static-1.8846",
  "customer-data-tracking": "static-1.6699",
  "conditional-properties-service-client": "static-1.3640",
  "crm-pipelines-api-client-types": "static-1.3982",
  "multi-currency-client-types": "static-1.3534",
  "external-options-client-types": "static-1.4001",
  "react-dnd-compat": "static-1.4438",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5176",
  "growth-onboarding-confetti": "static-1.2890",
  "growth-onboarding-next-action-utils": "static-1.1338",
  "onboarding-tours-utils": "static-1.358",
  "ui-shepherd-tracker": "static-1.7345",
  "academy-service-client": "static-1.3497",
  "final-form": "static-1.66",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27992",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8202",
  "video-components-external": "static-1.10623",
  "video-data-lib": "static-1.34281",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8385",
  "payment-link-components": "static-1.22989",
  "ui-addon-emoji-picker": "static-1.9705",
  "EmailSignatureEditor": "static-1.23951",
  "viral-links-lib": "static-1.6854",
  "data-token-picker": "static-1.16075",
  "FileManagerLib": "static-1.38593",
  "react-flip-move": "static-1.66",
  "timezone-utils": "static-2.5062",
  "getting-started-shared-tasks-store": "static-1.17054",
  "campaign-roi-lib": "static-1.8333",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.211",
  "eligibility-engine-service-types": "static-1.3011",
  "crm_data": "static-4.91283",
  "crm-links": "static-1.6084",
  "customer-data-sidebar": "static-2.45468",
  "enrichment-properties-lib": "static-1.15103",
  "crm-fe-perf": "static-1.22724",
  "calling-global-api": "static-1.63744",
  "calling-internal-common": "static-1.31112",
  "calling-lifecycle-internal": "static-1.65126",
  "calling-lifecycle-messages": "static-1.57420",
  "commerce-products-lib": "static-1.8912",
  "google-libphonenumber": "static-1.34",
  "hs-entities": "static-1.497",
  "inbounddb-objects-service-types": "static-1.4064",
  "meetings-icalendar-utils-lib": "static-1.450",
  "object-builder-ui-client": "static-1.48052",
  "pipeline-validation-client-types": "static-1.3805",
  "property-value-citations": "static-1.1464",
  "pulse": "static-1.333",
  "smart-property-lib": "static-1.5985",
  "tiered-pricing": "static-1.856",
  "ui-addon-form-validation": "static-1.10812",
  "growth-onboarding-next-action-components": "static-1.1366",
  "user-context-client": "static-1.4477",
  "growth-onboarding-feedback-components": "static-1.6401",
  "content-media-composition-data-lib": "static-1.11526",
  "content-media-compositions": "static-2.15533",
  "media-bridge-lib": "static-1.18598",
  "commerce-tours-lib": "static-1.5747",
  "growth-onboarding-reliability": "static-1.4904",
  "sales-checkout-service-client": "static-1.3485",
  "draft-convert": "static-2.68",
  "draft-extend": "static-3.71",
  "draft-js": "static-5.73",
  "draft-plugins": "static-2.21340",
  "sales-email-signature-service-client": "static-1.3662",
  "audio-components": "static-1.5639",
  "FileManagerCore": "static-1.38452",
  "FileManagerImages": "static-1.36104",
  "video-components": "static-1.12626",
  "crm_universal": "static-1.21693",
  "customer-data-email": "static-1.17703",
  "calling-error-reporting": "static-1.31118",
  "card-payment-highlight-lib": "static-1.36551",
  "card-subscription-highlight-lib": "static-1.38908",
  "commerce-billing-lib": "static-1.18550",
  "commerce-contract-lib": "static-1.11261",
  "customer-data-content": "static-1.26907",
  "invoices-highlight-card-lib": "static-1.54089",
  "orders-highlight-card-lib": "static-1.20915",
  "products-highlight-card-lib": "static-1.17196",
  "project-storage": "static-1.4551",
  "quotes-highlight-card-lib": "static-1.71282",
  "breeze-intelligence-kit": "static-1.5348",
  "crm-source-interpretation-lib": "static-1.5147",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9602",
  "policy-lib": "static-1.6605",
  "shared-worker-versioning": "static-1.10856",
  "calling-usage-tracker": "static-1.6359",
  "voice-sms-access-library": "static-1.299",
  "commerce-permissions": "static-1.577",
  "products-iframe-lib": "static-1.7376",
  "products-ui-components-shared-msw-handlers": "static-1.9901",
  "directed-graph": "static-1.757",
  "event-emitter": "static-1.765",
  "react-tinymce": "static-1.54671",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9665",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53797",
  "tinymce-plugins": "static-1.56911",
  "tinymce-themes": "static-1.55767",
  "hls.js": "static-1.35",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4350",
  "video-embed": "static-1.35115",
  "social-insights-client-types": "static-1.21420",
  "sequences-lib": "static-1.7716",
  "ui-gdpr-components": "static-1.10165",
  "commerce-shared-components-lib": "static-1.17991",
  "commerce-subscription-lib": "static-1.36485",
  "commerce-tools-ui-lib": "static-1.9843",
  "utility-belt": "static-1.2358",
  "payments-enrollment-embed-lib": "static-1.22074",
  "products-ui-components": "static-1.39431",
  "quotes-client-types": "static-1.37371",
  "quotes-ui-lib": "static-1.80002",
  "SalesContentIndexUI": "static-3.8929",
  "accounting-integrations-ui-components": "static-1.6753",
  "invoices-ui-lib": "static-1.54105",
  "commerce-products-api": "static-1.1983",
  "SafeStorage": "static-1.4221",
  "invoices-iframe-lib": "static-1.56163",
  "quotes-modal-lib": "static-1.101959",
  "calling-orchestration-schema": "static-1.35076",
  "sales-views-client-types": "static-1.4104",
  "hub-http-contrib": "static-1.2861",
  "interframe": "static-3.4606",
  "tinymce-data": "static-1.39882",
  "ui-addon-sales-email": "static-1.5031",
  "layout-dnd-components": "static-1.12073",
  "layout-dnd-utils": "static-1.11048",
  "ui-brand-identity-lib": "static-1.13996",
  "NamespacedHubStyle": "static-2.8913",
  "outpost": "static-1.4023",
  "sequences-client-types-lib": "static-1.7573",
  "customer-data-associations": "static-1.7157",
  "framework-data-table": "static-2.11458",
  "customer-data-rte": "static-1.32490",
  "cv-backend-services": "static-1.1506",
  "growth-onboarding-empty-states": "static-1.5393",
  "InboxConnectUtils": "static-4.14273",
  "payments-post-enroll-local-storage-lib": "static-1.4931",
  "qrcode-generator": "static-1.65",
  "stripe-embedded-components": "static-1.7166",
  "commerce-tax-lib": "static-1.334",
  "property-description-translator": "static-1.3675",
  "FireAlarmUi": "static-1.4348",
  "sales-templates-service-types-lib": "static-1.4008",
  "commerce-analytics-service-client": "static-1.3473",
  "totals-ui-components": "static-1.23045",
  "ContentData": "static-1.67751",
  "layout-data-lib": "static-1.9373",
  "deal-intel-decorators": "static-1.1312",
  "tanstack-virtual": "static-1.26",
  "draft-content-plugins": "static-1.27758",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3656",
  "advanced-menus-core": "static-1.14843",
  "advanced-menus-lib": "static-1.11814",
  "ui-memberships-settings-lib": "static-1.33489",
  "deal-intel-utils": "static-1.1316",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14842",
  "simple-menus-lib": "static-1.16359"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11615",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.449",
  "dashboard-client-types": "/dashboard-client-types/static-1.240",
  "data-fetching-client": "/data-fetching-client/static-1.9494",
  "foundations-components": "/foundations-components/static-1.7562",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.587",
  "foundations-theming": "/foundations-theming/static-1.4230",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.78",
  "head-dlb": "/head-dlb/static-1.4841",
  "hs-test-utils": "/hs-test-utils/static-1.7822",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9519",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11249",
  "I18n": "/I18n/static-7.1575",
  "jasmine-runner": "/jasmine-runner/static-1.6290",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11675",
  "quartz": "/quartz/static-1.6759",
  "react-dlb": "/react-dlb/static-1.73",
  "react-rhumb": "/react-rhumb/static-1.16469",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2680",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8538",
  "settings-ui-lib": "/settings-ui-lib/static-1.12340",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6769",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10961",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9363",
  "unified-auth": "/unified-auth/static-1.239",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.520",
  "usage-tracker": "/usage-tracker/static-1.7153",
  "usage-tracker-core": "/usage-tracker-core/static-1.7003",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7897",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6037",
  "integrations-lib": "/integrations-lib/static-1.15482",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19001",
  "property-management-iframe": "/property-management-iframe/static-1.12414",
  "quartz-config": "/quartz-config/static-1.537",
  "quartz-core": "/quartz-core/static-1.5978",
  "quartz-routing": "/quartz-routing/static-1.189",
  "quick-fetch": "/quick-fetch/static-1.3753",
  "react": "/react/static-7.180",
  "rpc-client-utils": "/rpc-client-utils/static-1.4452",
  "ts-schema": "/ts-schema/static-1.3921",
  "ui-universal-auth": "/ui-universal-auth/static-1.8725",
  "UIComponents": "/UIComponents/static-3.8196",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.405",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
  "PortalIdParser": "/PortalIdParser/static-2.367",
  "raven": "/raven/static-3.5725",
  "raven-hubspot": "/raven-hubspot/static-1.6032",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3246",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3036",
  "quartz-webpack": "/quartz-webpack/static-1.2983",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3831",
  "floating-ui": "/floating-ui/static-1.52",
  "foundations-assets": "/foundations-assets/static-1.4653",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1946",
  "framer-motion": "/framer-motion/static-1.68",
  "hs-story-utils": "/hs-story-utils/static-1.9244",
  "react-aria": "/react-aria/static-1.62",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5191",
  "react-virtualized": "/react-virtualized/static-2.95",
  "StyleGuideUI": "/StyleGuideUI/static-3.484",
  "tanstack-table": "/tanstack-table/static-1.51",
  "trellis-assets": "/trellis-assets/static-1.1269",
  "ui-fonts": "/ui-fonts/static-1.511",
  "ui-images": "/ui-images/static-2.1097",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2713",
  "foundations-theming-base": "/foundations-theming-base/static-1.3215",
  "stylex": "/stylex/static-1.28",
  "HeadJS": "/HeadJS/static-2.713",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2933",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.148",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.217",
  "moment-timezone": "/moment-timezone/static-5.79",
  "jasmine": "/jasmine/static-4.4144",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8400",
  "ai-rendering-library": "/ai-rendering-library/static-1.9359",
  "chirp-fetch": "/chirp-fetch/static-1.1700",
  "connections-embed-lib": "/connections-embed-lib/static-1.662",
  "copilot-toolkit": "/copilot-toolkit/static-1.10582",
  "laboratory-lib": "/laboratory-lib/static-3.6977",
  "marketplace-embed": "/marketplace-embed/static-1.21524",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8897",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18957",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13172",
  "sanitize-text": "/sanitize-text/static-1.7962",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8514",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5567",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4839",
  "wootric-nps": "/wootric-nps/static-1.6802",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4469",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3973",
  "highcharts": "/highcharts/static-8.100",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2387",
  "reporting-data": "/reporting-data/static-1.66605",
  "cssUtils": "/cssUtils/static-1.737",
  "flux-actions": "/flux-actions/static-1.310",
  "HubStyle": "/HubStyle/static-2.11557",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10028",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10190",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7143",
  "icons": "/icons/static-2.623",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17534",
  "storybook-react": "/storybook-react/static-1.29",
  "trellis-story-utils": "/trellis-story-utils/static-1.4338",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5045",
  "quartz-i18n": "/quartz-i18n/static-1.434",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3549",
  "customer-data-objects": "/customer-data-objects/static-1.7466",
  "property-translator": "/property-translator/static-1.5229",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7742",
  "hs-promise-utils": "/hs-promise-utils/static-1.5411",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4698",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12897",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5406",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7606",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4293",
  "superstore": "/superstore/static-1.4588",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9964",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7517",
  "hub-http-janus": "/hub-http-janus/static-1.798",
  "hubspotter-http": "/hubspotter-http/static-1.4495",
  "immutable-less": "/immutable-less/static-1.4472",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16408",
  "nav-meta": "/nav-meta/static-1.28967",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10056",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17684",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3691",
  "property-management-common": "/property-management-common/static-1.4701",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8864",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
  "module-federation": "/module-federation/static-1.19",
  "quartz-auth": "/quartz-auth/static-1.434",
  "quartz-head": "/quartz-head/static-1.424",
  "quartz-test": "/quartz-test/static-1.434",
  "quartz-tracking": "/quartz-tracking/static-1.138",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2968",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20409",
  "ContentUtils": "/ContentUtils/static-1.67676",
  "sassPrefix": "/sassPrefix/static-1.152",
  "avatar-components": "/avatar-components/static-1.2305",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38969",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12826",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12964",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13614",
  "ExportDialog": "/ExportDialog/static-6.10205",
  "highlight.js": "/highlight.js/static-1.75",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40705",
  "reporting-snowflake": "/reporting-snowflake/static-1.55223",
  "reporting-ui-components": "/reporting-ui-components/static-2.63876",
  "reporting-visualizations": "/reporting-visualizations/static-1.58681",
  "ui-addon-teams": "/ui-addon-teams/static-1.21267",
  "magpie-lib": "/magpie-lib/static-1.5412",
  "magpie-types": "/magpie-types/static-1.4872",
  "simple-logging-lib": "/simple-logging-lib/static-1.2868",
  "navigation-components": "/navigation-components/static-1.17330",
  "ai-studio-lib": "/ai-studio-lib/static-1.11050",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10301",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7810",
  "ui-tool-access": "/ui-tool-access/static-1.9963",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8058",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5570",
  "usage-tracker-public": "/usage-tracker-public/static-1.6964",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.56",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3437",
  "persist-promise": "/persist-promise/static-1.3525",
  "reference-resolvers": "/reference-resolvers/static-1.7979",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3761",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.157",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2818",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2235",
  "merchandise-lib": "/merchandise-lib/static-1.260",
  "atom": "/atom/static-1.4887",
  "purchase-motions-components": "/purchase-motions-components/static-1.5507",
  "salesImages": "/salesImages/static-1.521",
  "batch-promise": "/batch-promise/static-1.1368",
  "crm-component-utils": "/crm-component-utils/static-1.38524",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5690",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6691",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7912",
  "navigation-messaging": "/navigation-messaging/static-1.6657",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9517",
  "cms-field-types": "/cms-field-types/static-1.4624",
  "content-icons-ui": "/content-icons-ui/static-1.2160",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7066",
  "crm-message-bus": "/crm-message-bus/static-1.42417",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21404",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9640",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4546",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3850",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6596",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.792",
  "onboarding-tours": "/onboarding-tours/static-1.16292",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13111",
  "academy-common-lib": "/academy-common-lib/static-1.13074",
  "content-assistance-lib": "/content-assistance-lib/static-1.7476",
  "dashboard-lib": "/dashboard-lib/static-1.80704",
  "file-manager-components": "/file-manager-components/static-1.22953",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17936",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17654",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17646",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19504",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8511",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4583",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10734",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8847",
  "user-context": "/user-context/static-1.4916",
  "growth-payments-core": "/growth-payments-core/static-1.24778",
  "reporting-plugins": "/reporting-plugins/static-1.10009",
  "reporting-reports": "/reporting-reports/static-1.66283",
  "idb-keyval": "/idb-keyval/static-1.40",
  "reactive-lib": "/reactive-lib/static-1.542",
  "codemirror": "/codemirror/static-5.91",
  "feedback-loader": "/feedback-loader/static-1.28895",
  "react-codemirror": "/react-codemirror/static-1.10444",
  "apps-service-types": "/apps-service-types/static-1.3695",
  "oauth-service-types": "/oauth-service-types/static-1.4064",
  "onboarding-scopes": "/onboarding-scopes/static-1.6280",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4506",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7508",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14608",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8621",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4329",
  "nav-client-types": "/nav-client-types/static-1.2175",
  "purchase-motions-api": "/purchase-motions-api/static-1.5510",
  "signup-constants": "/signup-constants/static-1.18459",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3730",
  "card-properties-lib": "/card-properties-lib/static-1.43577",
  "crm-actions": "/crm-actions/static-1.6123",
  "crm-cards-data": "/crm-cards-data/static-1.1251",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42975",
  "customer-data-properties": "/customer-data-properties/static-1.50850",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8846",
  "customer-data-tracking": "/customer-data-tracking/static-1.6699",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3640",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3982",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3534",
  "external-options-client-types": "/external-options-client-types/static-1.4001",
  "react-dnd-compat": "/react-dnd-compat/static-1.4438",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5176",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2890",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1338",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.358",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7345",
  "academy-service-client": "/academy-service-client/static-1.3497",
  "final-form": "/final-form/static-1.66",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27992",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8202",
  "video-components-external": "/video-components-external/static-1.10623",
  "video-data-lib": "/video-data-lib/static-1.34281",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8385",
  "payment-link-components": "/payment-link-components/static-1.22989",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9705",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23951",
  "viral-links-lib": "/viral-links-lib/static-1.6854",
  "data-token-picker": "/data-token-picker/static-1.16075",
  "FileManagerLib": "/FileManagerLib/static-1.38593",
  "react-flip-move": "/react-flip-move/static-1.66",
  "timezone-utils": "/timezone-utils/static-2.5062",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17054",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8333",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.211",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3011",
  "crm_data": "/crm_data/static-4.91283",
  "crm-links": "/crm-links/static-1.6084",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45468",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15103",
  "crm-fe-perf": "/crm-fe-perf/static-1.22724",
  "calling-global-api": "/calling-global-api/static-1.63744",
  "calling-internal-common": "/calling-internal-common/static-1.31112",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65126",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57420",
  "commerce-products-lib": "/commerce-products-lib/static-1.8912",
  "google-libphonenumber": "/google-libphonenumber/static-1.34",
  "hs-entities": "/hs-entities/static-1.497",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4064",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.450",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48052",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3805",
  "property-value-citations": "/property-value-citations/static-1.1464",
  "pulse": "/pulse/static-1.333",
  "smart-property-lib": "/smart-property-lib/static-1.5985",
  "tiered-pricing": "/tiered-pricing/static-1.856",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10812",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1366",
  "user-context-client": "/user-context-client/static-1.4477",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6401",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11526",
  "content-media-compositions": "/content-media-compositions/static-2.15533",
  "media-bridge-lib": "/media-bridge-lib/static-1.18598",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5747",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4904",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3485",
  "draft-convert": "/draft-convert/static-2.68",
  "draft-extend": "/draft-extend/static-3.71",
  "draft-js": "/draft-js/static-5.73",
  "draft-plugins": "/draft-plugins/static-2.21340",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3662",
  "audio-components": "/audio-components/static-1.5639",
  "FileManagerCore": "/FileManagerCore/static-1.38452",
  "FileManagerImages": "/FileManagerImages/static-1.36104",
  "video-components": "/video-components/static-1.12626",
  "crm_universal": "/crm_universal/static-1.21693",
  "customer-data-email": "/customer-data-email/static-1.17703",
  "calling-error-reporting": "/calling-error-reporting/static-1.31118",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36551",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38908",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18550",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11261",
  "customer-data-content": "/customer-data-content/static-1.26907",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54089",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20915",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17196",
  "project-storage": "/project-storage/static-1.4551",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71282",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5348",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5147",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9602",
  "policy-lib": "/policy-lib/static-1.6605",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10856",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6359",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.299",
  "commerce-permissions": "/commerce-permissions/static-1.577",
  "products-iframe-lib": "/products-iframe-lib/static-1.7376",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9901",
  "directed-graph": "/directed-graph/static-1.757",
  "event-emitter": "/event-emitter/static-1.765",
  "react-tinymce": "/react-tinymce/static-1.54671",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9665",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53797",
  "tinymce-plugins": "/tinymce-plugins/static-1.56911",
  "tinymce-themes": "/tinymce-themes/static-1.55767",
  "hls.js": "/hls.js/static-1.35",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4350",
  "video-embed": "/video-embed/static-1.35115",
  "social-insights-client-types": "/social-insights-client-types/static-1.21420",
  "sequences-lib": "/sequences-lib/static-1.7716",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10165",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17991",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36485",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9843",
  "utility-belt": "/utility-belt/static-1.2358",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22074",
  "products-ui-components": "/products-ui-components/static-1.39431",
  "quotes-client-types": "/quotes-client-types/static-1.37371",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80002",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8929",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6753",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54105",
  "commerce-products-api": "/commerce-products-api/static-1.1983",
  "SafeStorage": "/SafeStorage/static-1.4221",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56163",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101959",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35076",
  "sales-views-client-types": "/sales-views-client-types/static-1.4104",
  "hub-http-contrib": "/hub-http-contrib/static-1.2861",
  "interframe": "/interframe/static-3.4606",
  "tinymce-data": "/tinymce-data/static-1.39882",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5031",
  "layout-dnd-components": "/layout-dnd-components/static-1.12073",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11048",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13996",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8913",
  "outpost": "/outpost/static-1.4023",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7573",
  "customer-data-associations": "/customer-data-associations/static-1.7157",
  "framework-data-table": "/framework-data-table/static-2.11458",
  "customer-data-rte": "/customer-data-rte/static-1.32490",
  "cv-backend-services": "/cv-backend-services/static-1.1506",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5393",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14273",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4931",
  "qrcode-generator": "/qrcode-generator/static-1.65",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7166",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.334",
  "property-description-translator": "/property-description-translator/static-1.3675",
  "FireAlarmUi": "/FireAlarmUi/static-1.4348",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4008",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3473",
  "totals-ui-components": "/totals-ui-components/static-1.23045",
  "ContentData": "/ContentData/static-1.67751",
  "layout-data-lib": "/layout-data-lib/static-1.9373",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1312",
  "tanstack-virtual": "/tanstack-virtual/static-1.26",
  "draft-content-plugins": "/draft-content-plugins/static-1.27758",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3656",
  "advanced-menus-core": "/advanced-menus-core/static-1.14843",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11814",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33489",
  "deal-intel-utils": "/deal-intel-utils/static-1.1316",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14842",
  "simple-menus-lib": "/simple-menus-lib/static-1.16359"
}
};
